import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TrabajadorInfoDialogComponent } from '../../AdmisionPersonal/_shared/trabajador-info-dialog/trabajador-info-dialog.component';
import { ObservacionDialogComponent } from '../../AdmisionPersonal/_shared/observacion-dialog/observacion-dialog.component';
import { ShowFotoDialogComponent } from '../../AdmisionPersonal/_shared/show-foto-dialog/show-foto-dialog.component';
import { TablaMensajesComponent } from '../../AdmisionPersonal/_shared/tabla-mensajes/tabla-mensajes.component';
import { EnableDisabledComponent } from '../../AdmisionPersonal/_shared/enable-disabled/enable-disabled.component';
import { AddEditCargoLaboralComponent } from '../../AdmisionPersonal/_shared/add-edit-cargo-laboral/add-edit-cargo-laboral.component';
import { PostulanteModel } from '../model/postulante.model';
import { TablaCargaMasivaComponent } from '../../AdmisionPersonal/_shared/tabla-carga-masiva/tabla-carga-masiva.component';
import { ImportAccionMasivaComponent } from '../../AdmisionPersonal/_shared/import-accion-masiva/import-accion-masiva.component';
import { ResultAccionMasivaComponent } from '../../AdmisionPersonal/_shared/result-accion-masiva/result-accion-masiva.component';
import { AddPersonaBlacklistComponent } from '../../AdmisionPersonal/_shared/add-persona-blacklist/add-persona-blacklist.component';
import { DialogResultadoBlacklistComponent } from '../../AdmisionPersonal/_shared/dialog-resultado-blacklist/dialog-resultado-blacklist.component';
import { FirmaContratoDialogComponent } from '../../AdmisionPersonal/_shared/firma-contrato-dialog/firma-contrato-dialog.component';
import { DialogProrrogaContratoComponent } from '../../AdmisionPersonal/_shared/dialog-prorroga-contrato/dialog-prorroga-contrato.component';
import { DialogResultProrrogaComponent } from '../../AdmisionPersonal/_shared/dialog-result-prorroga/dialog-result-prorroga.component';
import { AddEditJaladorDialogComponent } from '../../AdmisionPersonal/_shared/add-edit-jalador-dialog/add-edit-jalador-dialog.component';
import { AddEditAsignacionComponent } from '../../AdmisionPersonal/_shared/add-edit-asignacion/add-edit-asignacion.component';


@Injectable({
  providedIn: 'root'
})
export class UtilsHCM_APService {

  constructor(
    private dialog: MatDialog
  ) { }

  _infoPersonal_modal(title, postulante: PostulanteModel) {
    return this.dialog.open(TrabajadorInfoDialogComponent, {
      data: { title, postulante },
      width: '900px',
      disableClose: true
    });
  }
  _infoObservacion(title, Observacion) {
    return this.dialog.open(ObservacionDialogComponent, {
      data: { title, Observacion },
      width: '500px'
    });
  }

  _showFoto(title, base_64) {
    return this.dialog.open(ShowFotoDialogComponent, {
      data: { title, base_64 },
      width: '600px'
    });
  }

  _tabla_mensajes(title, array_data) {
    return this.dialog.open(TablaMensajesComponent, {
      data: { title, array_data },
      width: '600px',
      disableClose: true
    });
  }

  _enable_disable(title, desc, button_name) {
    return this.dialog.open(EnableDisabledComponent, {
      data: { title, desc, button_name },
      width: '400px',
      disableClose: true
    });
  }
  
  _add_edit_CargoLaboral(title, item, is_insert, button_name) {
    return this.dialog.open(AddEditCargoLaboralComponent, {
      data: { title, item,is_insert, button_name },
      width: '400px',
      disableClose: true
    });
  }

  _add_edit_blacklist(title, item, is_insert, button_name) {
    return this.dialog.open(AddPersonaBlacklistComponent, {
      data: { title, item,is_insert, button_name },
      width: '500px',
      disableClose: true
    });
  }

  _tabla_carga_masiva(title) {
    return this.dialog.open(TablaCargaMasivaComponent, {
      data: { title },
      width: '900px',
      disableClose: true
    });
  }

  _import_accionMasiva(title: string = '') {
    return this.dialog.open(ImportAccionMasivaComponent, {
      data: { title },
      width: '500px',
      disableClose: true
    });
  }

  _result_accionMasiva(title: string = '', data: any) {
    return this.dialog.open(ResultAccionMasivaComponent, {
      data: { title, data },
      width: '900px',
      disableClose: true
    });
  }
  
  _importarBlackList(items) {
    return this.dialog.open(DialogResultadoBlacklistComponent, {
      data: { items },
      width: '900px',
      disableClose: true
    });
  }
  
  _firmaContrato(title, items) {
    return this.dialog.open(FirmaContratoDialogComponent, {
      data: { title: title, model: items },
      width: '600px',
      disableClose: true
    });
  }

  _prorroga_contratos(title, datos, empresa) {
    return this.dialog.open(DialogProrrogaContratoComponent, {
      data: { title: title, datos, empresa },
      width: '600px',
      disableClose: true
    });
  }
  
  _result_validacion_prorroga(title, datos) {
    return this.dialog.open(DialogResultProrrogaComponent, {
      data: { title: title, datos },
      width: '800px',
      disableClose: true
    });
  }
  
  _add_edit_Jalador(title, item, is_insert, button_name) {
    return this.dialog.open(AddEditJaladorDialogComponent, {
      data: { title, item,is_insert, button_name },
      width: '400px',
      disableClose: true
    });
  }
  
  _add_edit_asignacion(title, item, is_insert, button_name) {
    return this.dialog.open(AddEditAsignacionComponent, {
      data: { title, item,is_insert, button_name },
      width: '400px',
      disableClose: true
    });
  }

}
